<script>
import { container } from '@/js/util/tabs';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'TabsContainerTabpanel',
    defaultTag: 'div',
    mixins: [dynamicComponent],
    inject: { container },
    props: {
        id: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            default: 'show',
            validator: (value) => ['if', 'show'].includes(value),
        },
        transition: {
            type: String,
            default: 'transition',
        },
        transitionProps: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        active() {
            this.$emit('changedSlide');
            return this.container.activeTabpanel === this;
        },
        ariaLabelledby() {
            return this.container.tabs.find(this.isControlledByTab).id;
        },
    },
    created() {
        this.container.$emit('created:tabpanel', this);
        this.$on('delete', this.delete);
    },
    beforeDestroy() {
        this.$el.remove();
    },
    methods: {
        delete() {
            this.$destroy();
        },
        isControlledByTab({ controls }) {
            return controls === this.id;
        },
        createEl(createElement, data) {
            if (!(this.mode === 'show' || this.active)) {
                return undefined;
            }

            return createElement(this.is, data, this.$slots.default);
        },
    },
    render(createElement) {
        const { id, ariaLabelledby } = this;
        const data = {
            attrs: {
                id,
                'aria-labelledby': ariaLabelledby,
                role: 'tabpanel',
            },
        };

        if (this.mode === 'show') {
            data.directives = [{
                name: 'show',
                value: this.active,
            }];
        }

        const el = this.createEl(createElement, data);

        if (this.transition) {
            return createElement(
                this.transition,
                { props: this.transitionProps },
                [el],
            );
        }

        return el;
    },
};
</script>



// WEBPACK FOOTER //
// src/components/tabs/TabsContainerTabpanel.vue